/**
 * The mission types. The twelve of 1987 (01 §3, 03 §2) in the manual's order, then the twenty-four
 * of the expansion (10 §2) in the design document's order, numbered 13-36. Classic mode flies only
 * the originals; Operations, Practice and the Daily Drop draw from all thirty-six.
 */

export const ORIGINAL_ARCHETYPES = [
  'munitions-depot', 'code-book', 'enemy-aircraft', 'capture-officer',
  'pipeline', 'radar-array', 'sam-site', 'pow-camp',
  'photograph-aircraft', 'hostages', 'diversion', 'delayed-sabotage',
] as const;

export const EXPANSION_ARCHETYPES = [
  // demolition (13-20)
  'blow-bridge', 'supply-train', 'artillery-battery', 'relay-mast',
  'missile-convoy', 'fuel-depot', 'coastal-guns', 'ammo-barges',
  // intelligence (21-26)
  'steal-plans', 'wiretap', 'photograph-convoy', 'black-box', 'forward-observer', 'courier-ambush',
  // people (27-32)
  'downed-pilot', 'defector', 'eliminate-general', 'snatch-scientist', 'partisan-rendezvous', 'prison-break',
  // sabotage (33-35) and endurance (36)
  'power-station', 'mine-road', 'beacon', 'hold-crossing',
] as const;

export type OriginalArchetypeId = (typeof ORIGINAL_ARCHETYPES)[number];
export type ExpansionArchetypeId = (typeof EXPANSION_ARCHETYPES)[number];
export type ArchetypeId = OriginalArchetypeId | ExpansionArchetypeId;

/** All thirty-six, in mission-number order (index + 1 is the mission's number). */
export const ALL_ARCHETYPES: readonly ArchetypeId[] = [...ORIGINAL_ARCHETYPES, ...EXPANSION_ARCHETYPES];

/** One of the 1987 twelve? (Classic mode's list.) */
export function isOriginalArchetype(id: ArchetypeId): id is OriginalArchetypeId {
  return (ORIGINAL_ARCHETYPES as readonly string[]).includes(id);
}
